module.exports = __webpack_public_path__ + "static/media/greencars-og.211dd016.jpg";